import React from "react";
// import { Download, LineChart, Loader2 } from "lucide-react";
import WeeklyCostKpiCard from "@/features/cost/components/kpi/WeeklyCostKpiCard";
import type { WeekDetails } from "@/features/cost/types/weekly-cost-report.types";
import { LineChart } from "lucide-react";

interface KpiSummary {
  currentWeekCost?: number;
  changePercent?: number;
  avgDailyCost?: number;
  avgDailyChangePercent?: number;
}

interface WeeklyCostReportHeaderProps {
  currentWeek: WeekDetails;
  kpi?: KpiSummary;
  pdfLoading?: boolean;
  // onDownloadPDF?: () => void;
}

const WeeklyCostReportHeader: React.FC<WeeklyCostReportHeaderProps> = ({
  currentWeek,
  kpi,
  //pdfLoading,
  // onDownloadPDF,
}) => {
  return (
    <div
      className="shrink-0 flex flex-col gap-3 bg-[var(--bg-canvas)] px-3 py-3 lg:flex-row lg:items-center lg:justify-between md:px-[18px]"
      style={{ boxShadow: "inset 0 -1px 0 var(--border-default)" }}
    >
      <div className="flex items-start sm:items-center gap-3 min-w-0">
        <div className="size-12 shrink-0 rounded-[10px] border border-[var(--border-subtle)] bg-[var(--bg-elevated)] flex items-center justify-center">
          <LineChart
            size={26}
            className="text-[var(--text-primary)]"
            strokeWidth={2}
          />
        </div>
        <div className="min-w-0">
          <div className="text-[19px] text-base font-semibold leading-[1.2] text-[var(--text-primary)] break-words">
            Cloud Cost - <span className="text-[var(--text-info)]">Weekly Report</span>
          </div>
          <div className="mt-[3px] text-[10px] md:text-[11px] text-[var(--text-secondary)] break-words">
            {currentWeek.fullLabel}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap items-stretch sm:items-center justify-start lg:justify-end gap-2 md:gap-3">
        <WeeklyCostKpiCard
          label="Total Spend"
          value={kpi?.currentWeekCost ?? 0}
          changePercent={kpi?.changePercent ?? 0}
        />
        <WeeklyCostKpiCard
          label="Avg Daily Cost"
          value={kpi?.avgDailyCost ?? 0}
          changePercent={kpi?.avgDailyChangePercent ?? 0}
        />
        {/* <button
          onClick={onDownloadPDF}
          disabled={pdfLoading}
          title="Download PDF"
          className="size-10 md:size-11 shrink-0 self-center rounded-[10px] border border-[var(--border-subtle)] bg-[var(--bg-elevated)] flex items-center justify-center text-[var(--text-primary)] transition-colors duration-150 hover:bg-[var(--bg-hover)] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
        >
          {pdfLoading ? (
            <Loader2 size={18} className="animate-spin" />
          ) : (
            <Download size={18} strokeWidth={2} />
          )}
        </button> */}
      </div>
    </div>
  );
};

export default WeeklyCostReportHeader;
